// tslint:disable:max-line-length

import React from 'react';

export const ObjectTag = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0 0v6l10 10 6-6-10-10h-6zm4 2c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z" />
    </svg>
  );
};
